import { getNavigationForPath, NAVIGATION_ROOTS } from './centerNavigation';

type MenuItem = {
  path?: string;
  name?: string;
  hideInMenu?: boolean;
  access?: string;
  permissionResourceCode?: string;
  children?: MenuItem[];
  [key: string]: unknown;
};

export function filterShellMenu<T extends MenuItem>(
  items: T[],
  access: Record<string, boolean | undefined>,
  pathname: string,
  permissionReady = true,
): T[] {
  const centerRoot = NAVIGATION_ROOTS[getNavigationForPath(pathname)];
  const filtered = items.flatMap((item) => {
    if (
      item.hideInMenu ||
      (permissionReady && item.access && !access[item.access]) ||
      (permissionReady &&
        item.permissionResourceCode &&
        !access[item.permissionResourceCode])
    )
      return [];
    if (
      item.path &&
      Object.values(NAVIGATION_ROOTS).includes(item.path) &&
      item.path !== centerRoot
    )
      return [];
    if (item.children) {
      const children = filterShellMenu(
        item.children,
        access,
        pathname,
        permissionReady,
      );
      if (
        children.length === 1 &&
        !item.path &&
        [
          '/attendance-center',
          '/payroll-center',
          '/social-insurance-center',
          '/performance-center',
        ].some((root) => pathname === root || pathname.startsWith(`${root}/`))
      ) {
        return [
          {
            ...children[0],
            icon: children[0].icon || item.icon,
          } as unknown as T,
        ];
      }
      return children.length ? [{ ...item, children } as T] : [];
    }
    return [item];
  });
  const seen = new Set<string>();
  return filtered.filter((item) => {
    const key = String(item.key || item.path || item.name || '');
    if (!key || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}
